import { Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseDialog } from '../../../../../ui/src/lib/dialogs/base/base.dialog';

export class UploadResultsDialogData {
  constructor(readonly failedUploads: string[], readonly successfulUploads?: string[], readonly isMultiple?: boolean) {}
}

@Component({
  selector: 'lc-upload-results-dialog',
  templateUrl: './upload-results-dialog.component.html',
  styleUrls: ['./upload-results-dialog.component.scss'],
  imports: [BaseDialog],
})
export class UploadResultsDialogComponent {
  data = inject<UploadResultsDialogData>(MAT_DIALOG_DATA);

  private readonly _close = new Subject();
  public readonly close = this._close.asObservable();

  onClose() {
    this._close.next(undefined);
  }
}
